import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {AccessService, guideKeys} from '../services/access.service';

export const newBlockGuard = (path: guideKeys):CanActivateFn => async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const access = inject(AccessService);
  const res = access.guide$.value;
  return res[path];
};
